import React, { useEffect }  from 'react';
import { pick, isEmpty, get } from 'lodash';
import PropTypes from 'prop-types';
import { Form, Input, Button } from '../components';
import { EXTENSION_NAME_OPTIONS, GENDER_OPTIONS } from '../constants';
import { SelectRegion, SelectProvince, SelectMunicipality, SelectBarangay } from '../containers';
import { useForm, useFormValidator, useSelect } from '../hooks';

const initialFormData = {
  representative_first_name: '',
  representative_middle_name: '',
  representative_last_name: '',
  representative_extension_name: '',
  representative_gender: '',
  representative_birth_date: '',
  representative_tin_number: '',
  representative_email: '',
  representative_contact_number: '',
  representative_street: '',
  
}

const rules = {
  representative_first_name: 'required|text_vapt',
  representative_last_name: 'required|text_vapt',
  representative_gender: 'required',
  representative_birth_date: 'required',
  representative_tin_number: 'required|tin_number',
  representative_email: 'required|email',
  representative_street: 'required',
  representative_contact_number: 'required|mobile_number',
}


const initFormDatarepresentativeAddress = {
  representative_region_id: '',
  representative_province_id: '',
  representative_municipality_id: '',
  representative_barangay_id: '',
}

const representativeAddressRules = {
  representative_region_id: 'required',
  representative_province_id: 'required',
  representative_municipality_id: 'required',
  representative_barangay_id: 'required',
}

export const options = {
  initialFormData: {
    ...initialFormData,
    ...initFormDatarepresentativeAddress
  },
  rules: {
    ...rules,
    ...representativeAddressRules
  }
}

const RepresentativeForm = ({  onNext, initialValue, onPrevious }) => {
  
  const [value, { onChange, onSetForm }] = useForm(initialFormData)
  const { response, renderMessage, onSetObjectRules } = useFormValidator(value, {})

  const [representativeAddressFormData, representativeAddressFormAction] = useForm(initFormDatarepresentativeAddress)
  const representativeAddressFormValidator = useFormValidator(representativeAddressFormData, {})
  
  const ownershipType = useSelect('ownershipType.selected')
  
  const combinedPayload = {
    ...value,
    ...representativeAddressFormData
  }

  useEffect(() => {
  
    if(!isEmpty(value.representative_first_name)){
      onSetObjectRules(rules)
      representativeAddressFormValidator.onSetObjectRules(representativeAddressRules)
    }

    if([2,3,4].indexOf(+get(ownershipType, 'id')) > -1){
      onSetObjectRules(rules)
      representativeAddressFormValidator.onSetObjectRules(representativeAddressRules)
    }
    
    if([1].indexOf(+get(ownershipType, 'id')) > -1 && isEmpty(value.representative_first_name)){
      onSetObjectRules({})
      representativeAddressFormValidator.onSetObjectRules({})
    }
    
    // eslint-disable-next-line
  }, [Object.values(value).join(',')])
  
  useEffect(() => {
    onSetForm(pick(initialValue, Object.keys(initialFormData)))
    representativeAddressFormAction.onSetForm(pick(initialValue, Object.keys(initFormDatarepresentativeAddress)))
    // eslint-disable-next-line
  }, [Object.values(initialValue).join(',')])
  
  const isValidationPassed = (response.is_passed && representativeAddressFormValidator.response.is_passed)
  
  const isPassedValidationOnIndividual = !isEmpty(value.representative_first_name)
  return (
    <>
      <Form.FormGroup className="form-group-4">
        <Input label="First Name" name="representative_first_name" onChange={onChange} value={value.representative_first_name} helperMessage={renderMessage}/>
        <Input label="Middle Name" name="representative_middle_name" onChange={onChange} value={value.representative_middle_name} helperMessage={renderMessage}/>
        <Input label="Last Name" name="representative_last_name" onChange={onChange} value={value.representative_last_name} helperMessage={renderMessage}/>
        <Input type="select" options={EXTENSION_NAME_OPTIONS} label="Extension Name" name="representative_extension_name" onChange={onChange} value={value.representative_extension_name} helperMessage={renderMessage}/>
      </Form.FormGroup>
      <Form.FormGroup  className="form-group-4">
        <Input type="select" options={GENDER_OPTIONS} label="Gender" name="representative_gender" onChange={onChange} value={value.representative_gender} helperMessage={renderMessage}/>
        <Input type="date" maxDate={new Date()} label="Birth Date" name="representative_birth_date" onChange={onChange} value={value.representative_birth_date} helperMessage={renderMessage}/>
        <Input type="mask" mask="999-999-999-99999" placeholder='---_---_---_-----' label="TIN Number" name="representative_tin_number" onChange={onChange} value={value.representative_tin_number} helperMessage={renderMessage}/>
        <Input label="Email" name="representative_email" onChange={onChange} value={value.representative_email} helperMessage={renderMessage}/>
      </Form.FormGroup>
      <Form.FormGroup className="form-group-4">
        <Input type="mask" mask="99999999999" placeholder='09000000000' label="Contact Number" name="representative_contact_number" onChange={onChange} value={value.representative_contact_number} helperMessage={renderMessage}/>
      </Form.FormGroup>
      <span className="text-success text-sm font-bold">Address</span>
      <Form.FormGroup className="form-group-4">
        <SelectRegion 
          prefixName="representative_"
          onChange={representativeAddressFormAction.onChange} 
          value={representativeAddressFormData.representative_region_id} 
          helperMessage={representativeAddressFormValidator.renderMessage}  
        />
        <SelectProvince 
          prefixName="representative_"
          region_id={representativeAddressFormData.representative_region_id} 
          onChange={representativeAddressFormAction.onChange} 
          value={representativeAddressFormData.representative_province_id} 
          helperMessage={representativeAddressFormValidator.renderMessage}  
        />
        <SelectMunicipality 
          prefixName="representative_"
          region_id={representativeAddressFormData.representative_region_id} 
          province_id={representativeAddressFormData.representative_province_id} 
          onChange={representativeAddressFormAction.onChange} 
          value={representativeAddressFormData.representative_municipality_id} 
          helperMessage={representativeAddressFormValidator.renderMessage}  
        />
        <SelectBarangay 
          prefixName="representative_"
          region_id={representativeAddressFormData.representative_region_id} 
          province_id={representativeAddressFormData.representative_province_id} 
          municipality_id={representativeAddressFormData.representative_municipality_id} 
          onChange={representativeAddressFormAction.onChange} 
          value={representativeAddressFormData.representative_barangay_id} 
          helperMessage={representativeAddressFormValidator.renderMessage}  
        />
      </Form.FormGroup>
      <Form.FormGroup className="form-group">
        <Input label="Unit/Room number/Floor, Building Name, House number, Street
                  name." name="representative_street" onChange={onChange} value={value.representative_street} helperMessage={renderMessage}/>
      </Form.FormGroup>
      <div className="flex space-x-2 float-right">
      <Button type="button" onClick={onPrevious(combinedPayload)} className="!bg-warning !w-auto !text-black">Previous</Button>
        <Button 
          disabled={[2,3,4].indexOf(+get(ownershipType, 'id')) > -1 ? !isValidationPassed : isPassedValidationOnIndividual && !isValidationPassed}
          type="button" onClick={onNext(combinedPayload)} className="!bg-warning !w-auto !text-black">Next</Button>
      </div>
    </>
  )
}


RepresentativeForm.propTypes = {
  onNext: PropTypes.instanceOf(Function).isRequired,
  initialValue: PropTypes.instanceOf(Object).isRequired
}

RepresentativeForm.displayName = 'RepresentativeForm'


export default RepresentativeForm